// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3a4BJ","label":"Completed_label__2aDBD"};